const AboutStory = () => {
  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div>
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6" style={{ fontFamily: 'serif' }}>
              Ons Verhaal
            </h2>
            <div className="space-y-6 text-gray-700 leading-relaxed">
              <p>
                NGP Renovatieproject is ontstaan uit een passie voor het transformeren van ruimtes en het creëren van droomwoningen. Met jarenlange ervaring in de bouw- en renovatiesector, hebben we onszelf gespecialiseerd in hoogwaardige afwerking en maatwerk renovaties.
              </p>
              <p>
                Elk project behandelen we met dezelfde toewijding en aandacht voor detail. Van kleine badkamerrenovaties tot complete woningtransformaties - we streven altijd naar perfectie en klanttevredenheid.
              </p>
              <p>
                Ons team bestaat uit ervaren vakmensen die hun vak door en door kennen. We werken alleen met de beste materialen en moderne technieken om een resultaat te leveren dat generaties meegaat.
              </p>
            </div>
          </div>
          <div className="relative">
            <div className="aspect-[4/5] rounded-3xl overflow-hidden shadow-2xl">
              <img
                src="https://public.readdy.ai/ai/img_res/2612f323b1f125737eea21745e68a589.jpg"
                alt="NGP Renovatieproject Team"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutStory;